var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"photoViewer"},_vm._l((_vm.photos),function(photo,index){return _c('b-img',{key:index,staticStyle:{"width":"85px","height":"85px","cursor":"pointer"},attrs:{"src":photo.url}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }